import './checkTouch';

let tileEvent = 'click';
let dragging = false;

if (isTouchDevice()) {
  tileEvent = 'touchend';
  document.body.addEventListener('touchmove', ()=> {
    dragging = true;
  });
  document.body.addEventListener('touchstart', ()=> {
    dragging = false;
  });
}

function clickableTile() {

  if (!dragging) {
    console.log(event.target);
    const thisURL = event.target.querySelector('a').getAttribute('href');
    window.location = thisURL;
  }
  // event.stopPropagation();
}

const tiles = document.querySelectorAll('.js-click');
tiles.forEach(tile => tile.addEventListener(tileEvent, clickableTile));



// WEBPACK FOOTER //
// ./scripts/util/clickTile.js